import script from "./RepresentanteMoreSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./RepresentanteMoreSheet.vue?vue&type=script&setup=true&lang=js"

import "./RepresentanteMoreSheet.vue?vue&type=style&index=0&id=0141b643&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0141b643"]])

export default __exports__